import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";

import FormContext from "../context/FormContext";
import ClientContext from "../context/ClientContext";
import { Container } from "react-bootstrap";

import Styles from "../styles.module.scss";
import { FormType } from "../types/Types";

import { clientsInfo } from "../utils/clientsInfo";

export const ThirdForm: () => JSX.Element = () => {
  const history = useHistory();
  const { formData, setFormData } = useContext(FormContext);
  const { client } = useContext(ClientContext);
  const [selected, setSelected] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue
  } = useForm();

  useEffect(() => {
    if (client === "Client 1" || client === "Client 2") {
      setValue("clientCountry", clientsInfo.client1.country);
      setValue("clientCity", clientsInfo.client1.city);
      setValue("clientZip", clientsInfo.client1.zip);
      setSelected(true);
    }
  }, [client]);

  useEffect(() => {
    if (!formData?.projectName) {
      history.push("/example/forms-challenge/");
    }
  }, [formData]);

  const submitVoid = (data: FormType) => {
    if (!errors.length) {
      setFormData({ ...formData, ...data });
      history.push("/example/forms-challenge/four");
    }
  };

  const coutryInput = watch("clientCountry");

  return (
    <Container className={Styles.mainContainer}>
      <Link to={"/example/forms-challenge/second"}>Volver</Link>

      <form onSubmit={handleSubmit(submitVoid)}>
        <p className='mt-3 font-weight-bold'>Pais</p>
        <input
          type='text'
          className={Styles.formTextInput}
          placeholder='Pais '
          {...register("clientCountry", { required: true, maxLength: 80 })}
          disabled={selected ? true : false}
        />
        {formData?.projectLevel === "High" &&
        coutryInput !== "Estados Unidos" ? (
          <p className={Styles.errorP}>
            Al elegir el nivel de importancia: {formData?.projectLevel}, el
            unico pais disponible es "Estados Unidos"
          </p>
        ) : (
          ""
        )}

        <p className='mt-2 font-weight-bold'>Ciudad</p>
        <input
          type='text'
          className={Styles.formTextInput}
          placeholder='Ciudad'
          {...register("clientCity", {
            required: true
          })}
          disabled={selected ? true : false}
        />
        {errors.clientCity?.type === "required" && (
          <p className={Styles.errorP}>Ingrese alguna ciudad</p>
        )}

        <p className='mt-2 font-weight-bold'>Codigo Postal</p>
        <input
          type='number'
          className={Styles.formTextInput}
          placeholder='Codigo Postal '
          {...register("clientZip", {
            required: true
          })}
          disabled={selected ? true : false}
        />
        {errors.clientZip?.type === "required" && (
          <p className={Styles.errorP}>Ingrese su codigo postal</p>
        )}

        <input type='submit' className={Styles.submitButton} />
      </form>
    </Container>
  );
};
